import React from "react";
import {colours} from "../../config";

const BlueBackground = () => {
  return (
    <div style={{backgroundColor: colours.prussianBlue, position: 'fixed', height: '100%', width: '100%', zIndex:-1, bottom: 0}} />
  )
}

export default BlueBackground;